import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ModalBaseContainer from '@max/leez-modal-base-container';
import TopView from '@max/leez-top-view';
import './index.scss';
import Sensor from '@max/mbc-sensor';
import LImage from '@max/leez-image';
const BottomSliderModal = (props) => {
    const { visible, onClose, children, title, height = 700, user, isMainState } = props;
    return <TopView>
      <ModalBaseContainer visible={visible} type="slide" slideFrom="bottom" onMaskPress={onClose} onClosed={onClose}>
        <View className="bottom-slider-modal">
          <View className="bottom-slider-modal__close-btn" onClick={onClose}>
            {/* <Icon
          
          type="body1"
          uri={'https://p0.meituan.net/ingee/6577f5e2ca67b9eb3328e46e5561f19f1862.png'}
         /> */}
            <LImage className="bottom-slider-modal__close-icon" source={{
            uri: "https://p0.meituan.net/ingee/574b9a57bea47152eeb9c96660d8be60562.png"
        }} style={{
            width: '32rpx'
        }}></LImage>
          </View>
          {title && <View className="bottom-slider-modal__header">
              {user?.userImage && <LImage x-if={!isMainState} source={{
                    uri: user.userImage
                }} style={{
                    width: '48rpx',
                    height: '48rpx',
                    borderRadius: '24rpx',
                    overflow: 'hidden',
                    marginRight: '8rpx'
                }}></LImage>}
              <Text className="bottom-slider-modal__title">{title}</Text>
            </View>}
          <Sensor>
            <View className="bottom-slider-modal__content" style={{
            height: `${height}rpx`
        }}>
              {children}
            </View>
          </Sensor>
        </View>
      </ModalBaseContainer>
    </TopView>;
};
export default memo(BottomSliderModal);
